import { HiOutlineUsers } from "react-icons/hi";
import UserManagement from "components/admin-panel/user_management/UserManagement";
import Title from "common/Title";
function User_Management({ logo }) {
  return (
    <>
      <Title
        color="rgb(244 124 96)"
        title="مدیریت کاربران"
        icon={HiOutlineUsers}
      />
      <div className="pt-5">{<UserManagement logo={logo} />}</div>
    </>
  );
}
export default User_Management;
